export default {
    get_product_name: (state) => ({ id }) => {
        var result = ''
        if (id) {
            var record = state.products.filter(p => { return p.id == id })[0]
            if (record) return record.name
        }
        return result
    }
}